import { combineReducers } from 'redux'
import dropdowncart from './dropdowncart'
import dropdownitems from './productitems'

export default combineReducers({
  dropdowncart,
  dropdownitems
})